import React, { useEffect, useRef } from 'react';
import QuoteWizard from './QuoteWizard';
import { IconX } from './Icons';

const LeadModalLuxury = ({ isOpen = false, onClose, presetService = null }) => {
  const modalRef = useRef(null);

  // Disable body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Handle Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  // Move focus into the dialog when it opens
  useEffect(() => {
    if (isOpen && modalRef.current) {
      const closeBtn = modalRef.current.querySelector('.bk-modal-close');
      if (closeBtn) closeBtn.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="bk-modal-backdrop"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="bk-modal-container"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="atcModalTitle"
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div className="bk-modal-card">
          <button
            type="button"
            className="bk-modal-close"
            aria-label="Close dialog"
            onClick={onClose}
          >
            <IconX size={16} />
          </button>
          <QuoteWizard
            formId="modalLeadForm"
            isModal={true}
            onCloseModal={onClose}
            presetService={presetService}
            titleId="atcModalTitle"
          />
        </div>
      </div>
    </>
  );
};

export default LeadModalLuxury;
